import React, { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import urljoin from 'url-join';

import PATHS from '../../constants/paths';
import { PageStatus } from '../../../types/__generated__';
import { SIZE_136_136 } from '../../constants/imageTemplateStrings';

import BenefactorListItem from '../BenefactorListItem/BenefactorListItem';
import PageSection from '../PageSection/PageSection';
import LoadMoreButton from '../LoadMoreButton/LoadMoreButton';

import styles from './TeamsList.scss';
import config from '../../client/config';

interface TeamsListProps {
  loading: boolean;
  hasNextPage: boolean;
  handleFetchMore: () => void;
  teamPages: Team[];
  totalCount: number;
  isLeaderboardTeamsList?: boolean;
}

export interface Team {
  id: string;
  target?: number;
  donationTotalAmount?: number;
  title: string;
  avatar?: string | null;
  currencyCode: string;
  donationsTotalCount?: number;
  slug: string;
  status?: PageStatus | null;
}

export const TeamsList: FunctionComponent<TeamsListProps> = ({
  loading,
  handleFetchMore,
  hasNextPage,
  teamPages,
  totalCount,
  isLeaderboardTeamsList = false,
}) => {
  return (
    <PageSection
      title="Teams"
      hasBorder
      count={totalCount}
      className={styles.container}
    >
      <ul data-qa="teams-list">
        {teamPages.map((teamPage: Team) => {
          let totaliserValue;
          if (
            teamPage.target &&
            teamPage.donationTotalAmount &&
            teamPage.target > 0
          ) {
            totaliserValue = Math.round(
              (teamPage.donationTotalAmount / teamPage.target) * 100,
            );
          }

          return (
            <>
              {isLeaderboardTeamsList ? (
                <BenefactorListItem
                  key={teamPage.id}
                  title={teamPage.title}
                  image={
                    teamPage?.avatar
                      ? `${teamPage?.avatar}?template=${SIZE_136_136}`
                      : ''
                  }
                  currencyCode={teamPage?.currencyCode || 'GBP'}
                  amount={
                    teamPage?.donationTotalAmount
                      ? teamPage.donationTotalAmount / 100
                      : 0
                  }
                  totaliserValue={totaliserValue ?? null}
                  supporterCount={teamPage.donationsTotalCount || 0}
                  url={
                    teamPage.slug
                      ? urljoin(config.baseUri, teamPage.slug)
                      : undefined
                  }
                  pageStatus={teamPage.status ?? PageStatus.Active}
                />
              ) : (
                <BenefactorListItem
                  key={teamPage.id}
                  title={teamPage.title}
                  image={
                    teamPage?.avatar
                      ? `${teamPage?.avatar}?template=${SIZE_136_136}`
                      : ''
                  }
                  currencyCode={teamPage?.currencyCode || 'GBP'}
                  amount={
                    teamPage?.donationTotalAmount
                      ? teamPage.donationTotalAmount / 100
                      : 0
                  }
                  totaliserValue={totaliserValue ?? null}
                  supporterCount={teamPage.donationsTotalCount || 0}
                  url={
                    teamPage.slug ? `${PATHS.TEAMS}${teamPage.slug}` : undefined
                  }
                  pageStatus={teamPage.status ?? PageStatus.Active}
                />
              )}
            </>
          );
        })}
      </ul>
      {hasNextPage && (
        <LoadMoreButton
          className="jg-btn"
          loading={loading}
          onClick={handleFetchMore}
          trackingData={{
            action_name: 'click',
            subtype: 'button',
            event: 'click',
            event_value: 'show more',
            sub_section: 'campaign members',
          }}
        >
          <Trans i18nKey="members.showMore">
            Show more
            <span className="jg-sr-only"> members</span>
          </Trans>
        </LoadMoreButton>
      )}
    </PageSection>
  );
};
